import { Injectable } from '@angular/core';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service'
import { TargetedGroupModel } from '../business-entities/targeted-group-model';
import { Urls } from '../../../../Autofacets-Core/src/app/utils/urls';
import { TargetGroupRequestModel } from '../business-entities/campaign-modal';

@Injectable({
  providedIn: 'root'
})
export class TargetedGroupDataService {

  constructor(private dataService: DataService) { }

  getTargetedGroups(requestModal: TargetGroupRequestModel): Promise<any> {
    return this.dataService.GetForCampaignServicePayload(Urls.TargetedGroup,requestModal).toPromise();
  }

  addtargetedGroup(param: TargetedGroupModel): Promise<any>{
    return this.dataService.PostForCampaignService<any>(Urls.TargetedGroup, param).toPromise();
  }

  deleteTargetedgroup(param: number): Promise<any>{
    return this.dataService.DeleteForCampaignService<any>(Urls.TargetedGroup, param).toPromise();
  }

  getCampaignMemberByQuery(param: any){
    return this.dataService.PostForCampaignService<any>(Urls.CampaignMember, param).toPromise();
  }

  GetCampaignMemberByCampaignId(id: any){
    return this.dataService.GetForCampaignServiceWithParam<any>(Urls.CampaignMember, id).toPromise();
  }

  InsertCampaignMembers(param: any){
    return this.dataService.PostForCampaignService<any>(Urls.CampaignMember+"/insert", param).toPromise();
  }
}
